// extracted by mini-css-extract-plugin
export default {"buttons":"ForgetModal_buttons__7NnCC","button":"ForgetModal_button__gnPyV"};